export default __webpack_public_path__ + "static/media/ic-filter-white.18e4e16b.svg";